import type { Academy } from '@mathflat/domain/Academy'

export type UserPropertiesSchema = {
  CRM학원분류값: Academy['customerType']
  D코드: Academy['academyId']
  학원명: Academy['name']
  이메일: Academy['email']
  등록학생수: Academy['studentCount']
  기관명: Academy['academyAdditionalData']['organizationName']
}

export const convertAcademyToUserProperties = ({
  academy,
}: {
  academy: Academy
}): Partial<UserPropertiesSchema> => {
  return {
    D코드: academy.academyId,
    학원명: academy.name,
    CRM학원분류값: academy.customerType,
    이메일: academy.email,
    등록학생수: academy.studentCount,
    기관명: academy.academyAdditionalData.organizationName,
  }
}
